module.exports = __webpack_public_path__ + "static/img/5.4174a85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxclose/5.png
// module id = Qg+Z
// module chunks = 1